/* eslint-disable */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';
import React from 'react';
import { compose } from 'recompose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import ModalPropTypes from './Modal.component.props';
import modalStyles from './Modal.component.styles';

/**
 * Modal
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const Modal = ({
  classes,
  paperClasses,
  dialogContentClasses,
  dialogTitleRootClasses,
  content,
  footer,
  icon,
  hideCloseIcon,
  maxWidth,
  onClose,
  open,
  preventFullScreen,
  rightHeading,
  title,
  width,
  onIconClick,
  paperScrollPaper = true,
  fullWidth = false,
}) => {
  const addProps = {};
  if (isWidthDown(`sm`, width) && !preventFullScreen) {
    addProps.fullScreen = true;
  } else if (paperClasses) {
    addProps.classes = { paper: paperClasses };
  }

  return (
    <Dialog
      classes={{ paperScrollPaper: paperScrollPaper && classes.paperScrollPaper }}
      aria-labelledby="simple-dialog-title"
      {...addProps}
      maxWidth={maxWidth || false}
      onClose={onClose}
      open={open}
      fullWidth={fullWidth}
    >
      <DialogTitle classes={{ root: dialogTitleRootClasses || classes.dialogTitleRoot }}>
        <Grid alignItems="center" className={classes.flexWrapNowrap} container>
          {addProps.fullScreen && !onIconClick && !hideCloseIcon && (
            <Grid item>
              <IconButton aria-label="Close" className={classes.iconButton} color="inherit" edge="start" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          )}
          {icon && !addProps.fullScreen && !onIconClick && (
            <Grid item className={classes.icon}>
              {icon}
            </Grid>
          )}
          {icon && onIconClick && (
            <IconButton aria-label="Close" className={classes.iconButton} color="inherit" edge="start" onClick={onIconClick}>
              {icon}
            </IconButton>
          )}
          <Grid className={classNames(classes.flexGrow1, classes.dialogTitleRoot)} item>
            {title}
          </Grid>
          <Grid className={classes.textAlignRight} item>
            {rightHeading}
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: classNames(dialogContentClasses || classes.dialogContent) }}>{content}</DialogContent>
      {footer && <DialogActions classes={{ root: classNames(classes.dialogFooter) }}>{footer}</DialogActions>}
    </Dialog>
  );
};

Modal.propTypes = ModalPropTypes;

export default compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(modalStyles), { withTheme: true }),
)(Modal);
